export const heroFacts = [
  { label: "资源类型", value: "剧集 · 小说 · 漫画" },
  { label: "观看形式", value: "分集 / 连播 / 原著阅读" },
  { label: "版本说明", value: "含无删减完整版指引" },
  { label: "整理范围", value: "入口导航 + 观看说明" },
];

export const heroTags = ["全集在线观看", "无删减版", "小说原著", "漫画目录", "分集导航"];

export const quickAccess = [
  {
    id: "qa-drama",
    icon: "ri-play-circle-line",
    title: "全集在线观看",
    desc: "汇总可分集播放与整季连播的浏览入口，按更新顺序整理，方便一次追完不迷路。",
    tags: ["分集", "连播", "高清"],
    anchor: "#resources",
    tone: "primary",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20illustration%20of%20a%20traditional%20Chinese%20mansion%20courtyard%20at%20golden%20hour%20with%20coral%20rose%20and%20gold%20lighting%2C%20elegant%20decorative%20art%20style%2C%20soft%20haze%2C%20no%20text%2C%20editorial%20poster%20aesthetic%2C%20rich%20warm%20tones&width=800&height=600&seq=flnv-quick-drama-01&orientation=landscape",
  },
  {
    id: "qa-uncut",
    icon: "ri-film-line",
    title: "无删减版资源",
    desc: "说明完整版与常见删减版的差异，并给出识别完整版的方法与观看前需要注意的点。",
    tags: ["完整版", "未删减", "对比"],
    anchor: "#uncut",
    tone: "accent",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20vintage%20film%20reel%20and%20candle%20on%20a%20wooden%20table%2C%20warm%20amber%20and%20soft%20cream%20palette%2C%20decorative%20editorial%20art%20style%2C%20gentle%20shadows%2C%20no%20text%2C%20refined%20composition&width=800&height=600&seq=flnv-quick-uncut-02&orientation=landscape",
  },
  {
    id: "qa-novel",
    icon: "ri-book-2-line",
    title: "小说原著",
    desc: "按章节整理的阅读入口，含人物关系与主线梗概，适合想先看原著再追剧的读者。",
    tags: ["分章", "原著", "梗概"],
    anchor: "#resources",
    tone: "secondary",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20illustration%20of%20an%20open%20antique%20book%20with%20soft%20sage%20green%20and%20cream%20tones%2C%20warm%20paper%20texture%2C%20decorative%20editorial%20art%20style%2C%20calm%20natural%20light%2C%20no%20text%2C%20harmonious%20minimal%20composition&width=800&height=600&seq=flnv-quick-novel-03&orientation=landscape",
  },
  {
    id: "qa-comic",
    icon: "ri-image-2-line",
    title: "漫画版目录",
    desc: "分话更新的漫画目录，画面节奏与剧集情节的对应关系一目了然，方便对照浏览。",
    tags: ["分话", "彩色", "对照"],
    anchor: "#resources",
    tone: "accent",
    cover: "https://readdy.ai/api/search-image?query=Decorative%20illustration%20of%20overlapping%20manga%20panel%20frames%20with%20warm%20coral%20and%20gold%20accents%20on%20cream%20paper%2C%20editorial%20art%20style%2C%20soft%20studio%20lighting%2C%20no%20text%2C%20clean%20modern%20layout&width=800&height=600&seq=flnv-quick-comic-04&orientation=landscape",
  },
];

export const introImage = "https://readdy.ai/api/search-image?query=Elegant%20stylized%20illustration%20of%20a%20traditional%20Chinese%20mansion%20interior%20long%20corridor%20with%20lattice%20windows%2C%20warm%20coral%20rose%20and%20gold%20light%20streaming%20in%2C%20decorative%20art%20poster%20style%2C%20soft%20haze%2C%20no%20text%2C%20refined%20cinematic%20composition&width=900&height=1100&seq=flnv-intro-05&orientation=portrait";

export const introParagraphs = [
  "「风流女管家」是一部围绕宅门管家与主家之间关系展开的作品，剧情在职场手腕、人情往来与情感选择之间来回推进，既有轻松诙谐的日常，也有需要细品的转折。因为看点分散在剧集、原著小说与漫画三个版本里，很多观众常常在搜索时来回切换，反而找不到自己想看的那一版。",
  "本站把与它相关的常见入口集中整理在同一页：想看剧的可以直接进入分集或连播导航；在意完整度的可以先看无删减版说明，确认自己拿到的是完整版本；偏爱文字的可以按章节浏览小说原著；喜欢画面的则可以对照漫画目录。所有内容都是围绕同一个主题展开的导航与说明，不需要反复跳转。",
];

export const introStats = [
  { value: "3", label: "可供浏览的版本形式" },
  { value: "11", label: "分类整理的内容区块" },
  { value: "1 页", label: "看完即闭环，无需多级跳转" },
];

export const resourceGroups = [
  {
    key: "drama",
    label: "剧集",
    icon: "ri-tv-2-line",
    hint: "按观看方式整理，含连播、分集与完整版入口",
  },
  {
    key: "novel",
    label: "小说",
    icon: "ri-book-2-line",
    hint: "按章节推进整理，适合连续阅读",
  },
  {
    key: "comic",
    label: "漫画",
    icon: "ri-image-2-line",
    hint: "按话数更新整理，方便对照剧情",
  },
];

export const resourceItems = [
  {
    id: "drama-1",
    group: "drama",
    title: "全集连播通道",
    meta: "整季连播 · 已整理至全集",
    desc: "以整季为单位连续播放，适合一次追完、不想手动切集的人。建议在网络稳定时使用。",
    tags: ["连播", "高清", "全集"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20illustration%20of%20a%20grand%20mansion%20hall%20with%20lanterns%20glowing%20soft%20coral%20and%20gold%2C%20decorative%20editorial%20art%20style%2C%20gentle%20haze%2C%20no%20text%2C%20elegant%20atmosphere&width=600&height=400&seq=flnv-res-drama-101&orientation=landscape",
  },
  {
    id: "drama-2",
    group: "drama",
    title: "分集观看目录",
    meta: "逐集排列 · 支持按顺序追更",
    desc: "按集数顺序排列，方便定位具体某一段剧情，也便于和朋友对进度、聊名场面。",
    tags: ["分集", "追更", "顺序"],
    cover: "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20rows%20of%20ornate%20wooden%20doors%20along%20a%20mansion%20corridor%2C%20warm%20rose%20and%20cream%20tones%2C%20decorative%20art%20style%2C%20soft%20light%2C%20no%20text%2C%20rhythmic%20composition&width=600&height=400&seq=flnv-res-drama-102&orientation=landscape",
  },
  {
    id: "drama-3",
    group: "drama",
    title: "无删减完整版入口",
    meta: "完整时长 · 建议先读版本说明",
    desc: "以完整时长呈现的版本入口，观看前建议先对照「无删减说明」确认片长与内容是否一致。",
    tags: ["完整版", "未删减", "完整时长"],
    cover: "https://readdy.ai/api/search-image?query=Decorative%20illustration%20of%20an%20unrolled%20scroll%20and%20a%20candle%20on%20dark%20wood%2C%20warm%20amber%20glow%2C%20cream%20highlights%2C%20editorial%20art%20style%2C%20soft%20shadows%2C%20no%20text%2C%20refined%20mood&width=600&height=400&seq=flnv-res-drama-103&orientation=landscape",
  },
  {
    id: "drama-4",
    group: "drama",
    title: "预告与幕后花絮",
    meta: "短片合集 · 轻松向",
    desc: "汇总预告片与幕后片段，适合在正式追剧前先感受整体节奏与人物关系。",
    tags: ["预告", "花絮", "短片"],
    cover: "https://readdy.ai/api/search-image?query=Playful%20illustration%20of%20a%20clapperboard%20and%20soft%20curtain%20with%20coral%20and%20gold%20accents%20on%20cream%20background%2C%20decorative%20editorial%20style%2C%20bright%20warm%20light%2C%20no%20text%2C%20cheerful%20composition&width=600&height=400&seq=flnv-res-drama-104&orientation=landscape",
  },
  {
    id: "drama-5",
    group: "drama",
    title: "结局解析与彩蛋梳理",
    meta: "剧情向 · 建议看完正片再读",
    desc: "整理结局走向与容易忽略的伏笔，帮你看懂转折处的设计，适合已经追完的观众。",
    tags: ["解析", "伏笔", "彩蛋"],
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20illustration%20of%20a%20thread%20of%20connected%20glowing%20points%20over%20a%20mansion%20silhouette%2C%20deep%20rose%20and%20gold%20palette%2C%20decorative%20art%20style%2C%20mysterious%20soft%20light%2C%20no%20text&width=600&height=400&seq=flnv-res-drama-105&orientation=landscape",
  },
  {
    id: "drama-6",
    group: "drama",
    title: "主题曲与配乐合辑",
    meta: "音乐向 · 可单独收听",
    desc: "集中收录剧集相关的主题曲与配乐，方便复习剧情时同步回味整体氛围。",
    tags: ["主题曲", "配乐", "收藏"],
    cover: "https://readdy.ai/api/search-image?query=Decorative%20illustration%20of%20a%20traditional%20string%20instrument%20beside%20floating%20sound%20waves%2C%20warm%20amber%20and%20cream%20palette%2C%20editorial%20art%20style%2C%20soft%20glow%2C%20no%20text%2C%20serene%20mood&width=600&height=400&seq=flnv-res-drama-106&orientation=landscape",
  },
  {
    id: "novel-1",
    group: "novel",
    title: "小说 第 1—20 章 · 开篇试读",
    meta: "开篇阶段 · 世界观与人物登场",
    desc: "交代故事背景与主要人物关系，节奏偏铺垫，适合先确认整体基调再决定是否继续。",
    tags: ["开篇", "试读", "人物登场"],
    cover: "https://readdy.ai/api/search-image?query=Cozy%20illustration%20of%20a%20single%20open%20book%20with%20warm%20cream%20pages%20and%20sage%20green%20accents%2C%20paper%20texture%2C%20decorative%20editorial%20style%2C%20soft%20natural%20light%2C%20no%20text%2C%20calm%20minimal%20composition&width=600&height=400&seq=flnv-res-novel-201&orientation=landscape",
  },
  {
    id: "novel-2",
    group: "novel",
    title: "小说 第 21—60 章 · 主线推进",
    meta: "主线阶段 · 冲突集中",
    desc: "主线矛盾逐步展开，人物之间的立场与选择开始分化，是阅读体验最集中的一段。",
    tags: ["主线", "冲突", "推进"],
    cover: "https://readdy.ai/api/search-image?query=Illustration%20of%20stacked%20books%20with%20a%20warm%20sage%20and%20cream%20palette%2C%20one%20book%20open%20at%20the%20top%2C%20decorative%20editorial%20art%20style%2C%20gentle%20side%20light%2C%20no%20text%2C%20balanced%20composition&width=600&height=400&seq=flnv-res-novel-202&orientation=landscape",
  },
  {
    id: "novel-3",
    group: "novel",
    title: "小说 · 人物关系与结局走向",
    meta: "梳理向 · 含关系图说明",
    desc: "把分散在各章的人物关系集中说明，并给出结局相关线索的整理，方便快速回顾。",
    tags: ["关系", "结局", "梳理"],
    cover: "https://readdy.ai/api/search-image?query=Decorative%20illustration%20of%20interconnected%20circles%20and%20lines%20resembling%20a%20relationship%20map%2C%20warm%20sage%20green%20and%20cream%20tones%2C%20editorial%20art%20style%2C%20soft%20light%2C%20no%20text%2C%20clear%20layout&width=600&height=400&seq=flnv-res-novel-203&orientation=landscape",
  },
  {
    id: "novel-4",
    group: "novel",
    title: "小说 · 番外与外传",
    meta: "补充篇 · 主线之外的日常",
    desc: "收录主线之外的补充篇章，多为轻松日常与配角视角，适合追完主线后再读。",
    tags: ["番外", "外传", "日常"],
    cover: "https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20a%20small%20booklet%20next%20to%20a%20cup%20of%20tea%2C%20warm%20cream%20and%20sage%20green%20palette%2C%20cozy%20editorial%20art%20style%2C%20gentle%20afternoon%20light%2C%20no%20text%2C%20relaxed%20mood&width=600&height=400&seq=flnv-res-novel-204&orientation=landscape",
  },
  {
    id: "novel-5",
    group: "novel",
    title: "小说 · 阅读顺序建议",
    meta: "指引用 · 含跳读方案",
    desc: "针对只想快速了解主线的读者，给出可跳读的章节范围，避免被支线拖慢节奏。",
    tags: ["指引", "跳读", "主线"],
    cover: "https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20a%20winding%20path%20of%20small%20book%20shapes%20guiding%20toward%20a%20warm%20light%2C%20sage%20green%20and%20cream%20palette%2C%20editorial%20art%20style%2C%20no%20text%2C%20clear%20direction&width=600&height=400&seq=flnv-res-novel-205&orientation=landscape",
  },
  {
    id: "comic-1",
    group: "comic",
    title: "漫画 第 1—15 话 · 彩色版",
    meta: "彩色连载 · 画风统一",
    desc: "以彩色版本呈现开篇内容，画面重点放在人物神态与场景氛围，观感比纯文字更直观。",
    tags: ["彩色", "开篇", "连载"],
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20illustration%20of%20colorful%20manga%20panel%20frames%20arranged%20on%20a%20cream%20page%2C%20warm%20coral%20gold%20and%20rose%20accents%2C%20dynamic%20editorial%20style%2C%20no%20text%2C%20clean%20layout&width=600&height=400&seq=flnv-res-comic-301&orientation=landscape",
  },
  {
    id: "comic-2",
    group: "comic",
    title: "漫画 第 16—40 话 · 主线篇",
    meta: "持续更新 · 剧情密集",
    desc: "对应作品主线的中段内容，分镜节奏明显加快，适合喜欢画面冲击感的读者。",
    tags: ["主线", "分镜", "更新"],
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20illustration%20of%20overlapping%20action%20manga%20panels%20with%20speed%20lines%2C%20warm%20coral%20and%20gold%20palette%20on%20cream%2C%20editorial%20art%20style%2C%20no%20text%2C%20energetic%20composition&width=600&height=400&seq=flnv-res-comic-302&orientation=landscape",
  },
  {
    id: "comic-3",
    group: "comic",
    title: "漫画 · 黑白收藏版",
    meta: "黑白呈现 · 线条细节更清晰",
    desc: "以黑白版本重新呈现部分章节，线条与构图细节更突出，适合偏好原稿质感的读者。",
    tags: ["黑白", "收藏", "线条"],
    cover: "https://readdy.ai/api/search-image?query=Elegant%20monochrome%20manga%20style%20illustration%20of%20a%20quiet%20courtyard%20scene%2C%20fine%20ink%20linework%2C%20paper%20texture%2C%20no%20text%2C%20refined%20classic%20composition&width=600&height=400&seq=flnv-res-comic-303&orientation=landscape",
  },
  {
    id: "comic-4",
    group: "comic",
    title: "漫画与剧集对照表",
    meta: "对照向 · 按话数对应集数",
    desc: "把漫画话数与剧集集数做大致对照，方便在两种形式之间切换时保持进度同步。",
    tags: ["对照", "进度", "同步"],
    cover: "https://readdy.ai/api/search-image?query=Decorative%20illustration%20of%20two%20columns%20of%20cards%20connected%20by%20dotted%20lines%20like%20a%20comparison%20chart%2C%20warm%20gold%20and%20cream%20palette%2C%20editorial%20art%20style%2C%20no%20text&width=600&height=400&seq=flnv-res-comic-304&orientation=landscape",
  },
];

export const compareRows = [
  {
    aspect: "单集片长",
    full: "保持完整时长，剪辑连贯，转场更自然",
    cut: "为控制篇幅做过剪接，部分段落衔接较快",
  },
  {
    aspect: "剧情连贯性",
    full: "情节前后呼应完整，支线交代更清楚",
    cut: "个别过渡情节被压缩，需要自行补全上下文",
  },
  {
    aspect: "人物刻画",
    full: "配角戏份保留较多，人物动机更清晰",
    cut: "配角片段减少，主要集中在主角线",
  },
  {
    aspect: "情感段落",
    full: "情绪推进有铺垫，节奏完整",
    cut: "情绪段被缩短，观感略显跳跃",
  },
  {
    aspect: "结局呈现",
    full: "结尾收束完整，留有回味空间",
    cut: "结尾略作精简，部分细节需对照原著",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先确定想看的形式",
    desc: "是想追剧补番，还是更想看原著小说或漫画？先定下形式，后面的入口才好挑。",
  },
  {
    step: "02",
    title: "在观看入口里选对应通道",
    desc: "剧集选连播或分集，文字党选小说章节，画面党选漫画目录，一步到位。",
  },
  {
    step: "03",
    title: "在意完整度就先读版本说明",
    desc: "如果你在意剧情完整，先到「无删减说明」对照片长与差异，再决定用哪个版本。",
  },
  {
    step: "04",
    title: "按顺序推进，随时回到本页",
    desc: "所有入口都指向本页分区，看累了想换形式，直接跳回对应区块即可。",
  },
];

export const characters = [
  {
    id: "c1",
    name: "沈星遥",
    role: "女管家",
    desc: "心思缜密，打理宅中大小事务游刃有余。表面温顺，关键时刻极有主见，是推动全局的关键人物。",
    tags: ["主线核心", "理智", "行动派"],
    cover: "https://readdy.ai/api/search-image?query=Elegant%20stylized%20character%20illustration%20portrait%20of%20a%20composed%20young%20woman%20in%20traditional%20Chinese%20attire%2C%20calm%20confident%20expression%2C%20warm%20coral%20rose%20and%20gold%20palette%2C%20decorative%20editorial%20art%20style%2C%20soft%20cream%20background%2C%20no%20text&width=500&height=620&seq=flnv-char-401&orientation=portrait",
  },
  {
    id: "c2",
    name: "顾言行",
    role: "少东家",
    desc: "年轻气盛、行事带点任性，与女管家在观念上频繁碰撞。随着剧情推进逐渐学会承担责任。",
    tags: ["成长线", "情感线"],
    cover: "https://readdy.ai/api/search-image?query=Stylized%20character%20illustration%20portrait%20of%20a%20proud%20young%20man%20in%20refined%20traditional%20Chinese%20robe%2C%20slightly%20defiant%20expression%2C%20warm%20amber%20and%20cream%20palette%2C%20decorative%20editorial%20art%20style%2C%20soft%20background%2C%20no%20text&width=500&height=620&seq=flnv-char-402&orientation=portrait",
  },
  {
    id: "c3",
    name: "苏婉",
    role: "同期管家",
    desc: "做事周到、擅长人际周旋，与主角既是同事也是对手，常在中立位置上给出意想不到的帮助。",
    tags: ["配角", "人情线"],
    cover: "https://readdy.ai/api/search-image?query=Refined%20character%20illustration%20portrait%20of%20a%20poised%20woman%20with%20a%20subtle%20smile%20in%20traditional%20Chinese%20dress%2C%20sage%20green%20and%20cream%20palette%2C%20decorative%20editorial%20art%20style%2C%20soft%20cream%20background%2C%20no%20text&width=500&height=620&seq=flnv-char-403&orientation=portrait",
  },
  {
    id: "c4",
    name: "陆秉文",
    role: "主家长辈",
    desc: "规矩森严、看重门面，一心想维持旧有秩序。态度强硬，却在细节处透露出对后辈的关心。",
    tags: ["长辈", "秩序线"],
    cover: "https://readdy.ai/api/search-image?query=Dignified%20character%20illustration%20portrait%20of%20a%20stern%20older%20man%20in%20formal%20traditional%20Chinese%20garments%2C%20warm%20brown%20gold%20and%20cream%20palette%2C%20decorative%20editorial%20art%20style%2C%20muted%20background%2C%20no%20text&width=500&height=620&seq=flnv-char-404&orientation=portrait",
  },
  {
    id: "c5",
    name: "林小满",
    role: "宅中侍女",
    desc: "性格活泼直率，是气氛调剂担当。看似不谙世事，却常常无意间点破关键线索。",
    tags: ["轻松线", "伏笔"],
    cover: "https://readdy.ai/api/search-image?query=Cheerful%20character%20illustration%20portrait%20of%20a%20lively%20young%20girl%20in%20simple%20traditional%20Chinese%20clothing%2C%20bright%20smile%2C%20warm%20coral%20and%20cream%20palette%2C%20decorative%20editorial%20art%20style%2C%20soft%20background%2C%20no%20text&width=500&height=620&seq=flnv-char-405&orientation=portrait",
  },
  {
    id: "c6",
    name: "程亦舟",
    role: "外来访客",
    desc: "身份成谜，几次出入宅门都与主线事件有隐约关联，是理解整体走向时容易被忽略的一环。",
    tags: ["悬念", "支线"],
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20character%20illustration%20portrait%20of%20a%20travelling%20man%20in%20a%20dark%20cloak%20with%20a%20wooden%20staff%2C%20deep%20rose%20gold%20and%20cream%20palette%2C%20decorative%20editorial%20art%20style%2C%20soft%20shadows%2C%20no%20text&width=500&height=620&seq=flnv-char-406&orientation=portrait",
  },
];

export const timeline = [
  {
    phase: "开篇 · 初入宅门",
    point: "人物关系铺开",
    desc: "以女管家接手宅中事务为引子，快速带出主要人物与矛盾方向，适合先建立整体印象。",
  },
  {
    phase: "转折 · 观念碰撞",
    point: "立场开始分化",
    desc: "管家与少东家在做事方式上产生分歧，剧情由日常转向冲突，是全剧节奏的第一个拐点。",
  },
  {
    phase: "深入 · 人情往来",
    point: "支线交织",
    desc: "配角依次登场，各自的故事与主线互相牵动，也是删减版中常被压缩的部分。",
  },
  {
    phase: "高点 · 危机浮现",
    point: "冲突集中爆发",
    desc: "前期埋下的线索在此汇聚，人物被迫做出选择，情绪张力达到全篇最强的一段。",
  },
  {
    phase: "收束 · 各归其位",
    point: "关系重新落定",
    desc: "各条支线陆续收尾，人物关系重新找到平衡，为结局做出铺垫。",
  },
  {
    phase: "尾声 · 留有余韵",
    point: "开放式收尾",
    desc: "结局并未把话说尽，留下可继续想象的空间，也呼应了原著开放式的处理方式。",
  },
];

export const faqs = [
  {
    q: "「风流女管家」一共有哪几种版本可以看？",
    a: "常见的有三种形式：剧集、原著小说和漫画。剧集又分为整季连播与分集观看两种通道，小说按章节推进，漫画按话数更新。你可以根据自己想追剧、看文字还是看画面，在本页对应区块里选择入口。",
  },
  {
    q: "无删减版和常见的删减版主要差在哪？",
    a: "主要差别在单集片长、剧情连贯性和配角戏份。完整版保留了更多过渡情节与情感铺垫，人物动机交代得更清楚；删减版为了控制篇幅会做剪接，个别段落衔接较快，需要结合原著补全上下文。",
  },
  {
    q: "怎么判断我拿到的是不是完整版本？",
    a: "可以先对照「无删减说明」里的片长与内容对比表，看几个关键转折段落是否连贯。如果发现情绪推进明显跳跃、配角支线突然消失，通常意味着内容被压缩过，建议换用完整版入口重新确认。",
  },
  {
    q: "没看过原著，直接看剧会影响理解吗？",
    a: "不会。剧集本身有完整的叙事线，可以直接看懂。不过如果中途觉得某些人物关系交代得不够，回到小说的人物关系梳理部分对照一下，会更容易理解角色之间的动机与立场。",
  },
  {
    q: "小说和漫画应该先看哪个？",
    a: "取决于你更在意文字还是画面。想快速掌握主线，可以先看小说主线章节；想先感受人物神态与氛围，可以先看漫画开篇。两者并不冲突，也不需要严格按顺序。",
  },
  {
    q: "只想快速了解剧情，有没有省时间的看法？",
    a: "可以看「阅读顺序建议」提供的跳读方案，只保留主线章节；剧集方面则建议先看分集目录里的关键转折集数，再回头补日常片段，这样能在较短时间里抓住整体走向。",
  },
  {
    q: "页面上的入口会持续整理吗？",
    a: "本页是一个导航与说明页，内容会围绕同一个主题分区整理。如果某个入口在浏览时体验不佳，可以换用同区块内的其他通道，两种形式对照着看通常更稳妥。",
  },
  {
    q: "这些内容是完全免费的吗？",
    a: "本页只做入口汇总与观看指引，不提供资源本身，也不代表任何版本的具体授权情况。不同通道的可用性与限制可能不同，请以你实际访问时的页面说明为准。",
  },
];